import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { productCategories } from "@/lib/productCategoryConfig";

export const productCategoryArticlesQueryOptions = (slug: string) => queryOptions({
  queryKey: ["product-cat-articles", slug],
  queryFn: async () => {
    const config = productCategories[slug];
    if (!config) return [];
    const orFilters = config.articleKeywords
      .map(kw => `title.ilike.%${kw}%,content.ilike.%${kw}%`)
      .join(",");
    const { data, error } = await supabase.from("articles")
      .select("id, title, slug, excerpt, featured_image, featured_image_alt, published_at")
      .eq("status", "published")
      .or(orFilters)
      .order("published_at", { ascending: false })
      .limit(12);
    if (error) throw error;
    return data || [];
  },
});

export const productCategoryTopListsQueryOptions = (slug: string) => queryOptions({
  queryKey: ["product-cat-toplists", slug],
  queryFn: async () => {
    const config = productCategories[slug];
    if (!config) return [];
    const orFilters = config.articleKeywords.map(kw => `title.ilike.%${kw}%`).join(",");
    const { data, error } = await supabase.from("top_lists")
      .select("id, title, slug, featured_image, featured_image_alt, meta_description")
      .eq("status", "published")
      .or(orFilters)
      .order("published_at", { ascending: false })
      .limit(6);
    if (error) throw error;
    return data || [];
  },
});